var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.environmentClass, 'd-flex flex-column'],attrs:{"id":"app"}},[_c('vue-progress-bar'),_c(_vm.layout,{tag:"component"}),_c('notifications',{attrs:{"classes":"vue-notification notification"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }